import React, {FunctionComponent} from "react";
import {FormattedMessage} from "react-intl";
import {Col, Row} from "reactstrap";
import {moneyUtils} from "../../../utils/moneyUtils";
import {Invoice, InvoiceType} from "../../../interfaces/InvoiceInterfaces";

interface BillingInvoiceSummaryDetailsProps {
  className?: string,
  invoice: Invoice,
}

const BillingInvoiceSummaryDetails: FunctionComponent<BillingInvoiceSummaryDetailsProps> = ({
  className = "",
  invoice,
}) => {
  return (
    <div className={className}>
      <Col xs={{offset: 16, size: 8}}>
        <div className="card m-2 p-2">
          {invoice.vatApplicable ? (
            <>
              <Row className="text-end">
                <Col xs={12} className="fw-bold"><FormattedMessage id="invoice_header_total_ht" /></Col>
                <Col xs={12}>{moneyUtils.formatNumberToCurrency(invoice.totalHT || invoice.amountHT)}</Col>
              </Row>
              {invoice.vatBreakdowns.map(vat => (
                <Row className="text-end" key={vat.vatRateId}>
                  <Col xs={12} className="fw-bold"><FormattedMessage id="purchase_booking_total" /> {vat.vatRateName}</Col>
                  <Col xs={12}>{moneyUtils.formatNumberToCurrency(vat.amountVAT)}</Col>
                </Row>
                )
              )}
              <Row className="text-end">
                <Col xs={12} className="fw-bold"><FormattedMessage id="invoice_header_total_ttc" /></Col>
                <Col xs={12}>{moneyUtils.formatNumberToCurrency(invoice.amountTTC)}</Col>
              </Row>
            </>
          ) : (
            <Row className="text-end">
              <Col xs={12} className="fw-bold"><FormattedMessage id="invoice_header_total_ht" /></Col>
              <Col xs={12}>{moneyUtils.formatNumberToCurrency(invoice.totalHT || invoice.amountHT)}</Col>
            </Row>
          )}
        </div>
      </Col>
      {invoice.amountDisbursement > 0 &&
        <Col xs={{offset: 16, size: 8}}>
          <div className="card m-2 p-2">
            <Row className="text-end">
              <Col xs={12} className="fw-bold"><FormattedMessage id="invoice_header_total_disbursement" /></Col>
              <Col xs={12}
                className="color-secondary">{moneyUtils.formatNumberToCurrency(invoice.amountDisbursement)}</Col>
            </Row>
            <Row className="text-end">
              <Col xs={12} className="fw-bold"><FormattedMessage id="invoice_header_total" /></Col>
              <Col
                xs={12}>{moneyUtils.formatNumberToCurrency(invoice.amountTTC + invoice.amountDisbursement)}</Col>
            </Row>
          </div>
        </Col>}
      {invoice.type === InvoiceType.INVOICE &&
        <Col xs={{offset: 16, size: 8}}>
          <div className="card m-2 p-2">
            <Row className="text-end">
              <Col xs={12} className="fw-bold"><FormattedMessage id="invoice_header_total_paid" /></Col>
              <Col xs={12}>{moneyUtils.formatNumberToCurrency(invoice.totalAmountPaid)}</Col>
            </Row>
            <Row className="text-end">
              <Col xs={12} className="fw-bold"><FormattedMessage id="invoice_header_total_remaining" /></Col>
              <Col xs={12}>{moneyUtils.formatNumberToCurrency(invoice.totalAmountRemaining)}</Col>
            </Row>
          </div>
        </Col>}
    </div>
  )
}

export default BillingInvoiceSummaryDetails;
